import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AnalyticsService } from 'src/app/services/administration/analytics.service';
import { AddAnalyticsBuilderComponent } from './add-analytics-builder/add-analytics-builder.component';
import { CommonService } from 'src/app/services/common.service';
import { PublishAnalyticsComponent } from './publish-analytics/publish-analytics.component';
import * as $ from 'jquery';
declare const initComposerEmbedManager: any;

@Component({
  selector: 'app-analytic-builder',
  templateUrl: './analytic-builder.component.html',
  styleUrls: ['./analytic-builder.component.scss']
})
export class AnalyticBuilderComponent implements OnInit, OnDestroy {

  userDashboards: any = [];
  user_Org_Accesstoken: string;
  options: NgbModalOptions;
  embedDashboardID: string = "";

  constructor(public analyticsService: AnalyticsService,private commonservice: CommonService,
    private modalService: NgbModal) { }


  ngOnInit(): void {
    this.options = {
      size: 'lg w-80',
      backdrop: false,
      windowClass: "right"
    };
    this.getDashboards();
    const elements = document.getElementsByClassName("embedDash")[0];
    elements.innerHTML = "";
    $("#embedDash").empty();
    //this.LoadDashboard();
  }
  ngOnDestroy(): void {
    const elements = document.getElementsByClassName("embedDash")[0];
    elements.innerHTML = "";
    $("#embedDash").empty();
  }

  AddSSR() {
    let modalRef = this.modalService.open(AddAnalyticsBuilderComponent, {
      backdrop: false,
      keyboard: false,
      windowClass:'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      user_Org_Accesstoken:this.user_Org_Accesstoken
    }
    modalRef.result.then(result=>{
      this.getDashboards();
    })
  }

  LoadDashboard(dashboardId?: string) {
    this.embedDashboardID = dashboardId ?? "";

    const elements = document.getElementsByClassName("embedDash")[0];
    elements.innerHTML = "";

    const getEmbedManagerPromise =
      initComposerEmbedManager({
        initialToken: this.user_Org_Accesstoken
      });

    getEmbedManagerPromise.then((embedManager: any) => {
      embedManager.createComponent('dashboard',
        {
          dashboardId: this.embedDashboardID,
          "theme": "modern",
          "editor": { "placement": "dockRight" },
          "header": {
            "showTitle": true,
          }
        }
      ).then((dashboard: any) => dashboard.render(
        document.getElementById("embedDash"),
        { width: '100%', height: '100%' }
      ))
    });
  }

  getDashboards() {
    this.analyticsService.getData("api/Analytics/UserDashboards").subscribe((response: any) => {
      if (response.Status != undefined && response.Status == 0) {
        this.userDashboards = response.Data.dashboards;
        this.user_Org_Accesstoken = response.Data.accessToken;
        if (this.userDashboards.length > 0) {
          this.LoadDashboard(this.userDashboards[0].LogiDashboardID.toString());
        }
        else{
          const elements = document.getElementsByClassName("embedDash")[0];
          elements.innerHTML = "";
        }
      } else {
        this.userDashboards = [];
        this.user_Org_Accesstoken = "";
      }
    });
  }

  DeleteDashboard(dashboardObj: any) {
    this.analyticsService.InsertDataPost("api/Analytics/DeleteSSR", dashboardObj).subscribe((response: any) => {
      if (response.Status != undefined && response.Status == 0) {
        this.getDashboards();
        this['self'].commonservice.successBaner(response.SuccessMessage);
      } else {
        this['self'].commonservice.ValidationBanner(response.Message);
      }
    });
  }

  ShareDashboard(dashboardObj: any, isUnshare: boolean = false) {
    if (!isUnshare) {
      // this.analyticsService.InsertDataPost("api/Analytics/ShareSSR", dashboardObj).subscribe((response: any) => {
      //   if (response.Status != undefined && response.Status == 0) {
      //     this.getDashboards();
      //     this.commonservice.SuccessBanner(response.SuccessMessage);
      //   } else {
      //     let err: any = [];
      //     err.push(response.errMessage);
      //     this.commonservice.ValidationBanner(err);
      //   }
      // });

      let modalRef = this.modalService.open(PublishAnalyticsComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-md modal-dialog-center',
        animation: true
      });
      modalRef.componentInstance.Content = {
        DashboardDetail: dashboardObj
      };
      modalRef.result.then((result) => {
        this.getDashboards();
      });
    }
    else {
      this.analyticsService.InsertDataPost("api/Analytics/UnshareSSR", dashboardObj).subscribe((response: any) => {
        if (response.Status != undefined && response.Status == 0) {
          this.getDashboards();
          this.commonservice.SuccessBanner("Dashboard unpublished successfully");
        } else {
          let err: any = [];
          err.push(response.errMessage);
          this.commonservice.ValidationBanner(err);
        }
      });
    }
  }
}
